var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSloveniaLotoPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 10,
    y: 10,
    width: 40,
    height: 40,
    viewBox: "-28.571 81.111 362.223 136.402",
    xmlSpace: "preserve",
    style: {
      background: "#ed1c24"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m130.476 116.19-11.111 52.593c-.212 1.059-.423 2.116-.423 2.857 0 1.48.847 2.222 2.434 2.222 1.587 0 3.492-.847 5.397-2.011l-2.011 9.63c-4.444 2.646-8.359 3.915-13.122 3.915-6.561 0-11.429-2.857-11.429-10.158 0-1.693.318-3.81.741-6.138l8.466-40h-6.667l2.751-12.91h24.974zm92.17 14.815 3.598-16.826-19.153 4.233-2.752 12.699h-8.889l-2.856 12.804h8.889l-4.233 19.894c-.528 2.54-.951 5.608-.951 7.725 0 9.101 6.983 13.862 16.508 13.862 5.926 0 11.746-1.693 15.132-3.703l2.328-11.111c-2.646 1.27-7.196 2.328-10.265 2.328-3.28 0-5.186-1.059-5.186-4.444 0-.847.212-2.223.424-3.175l4.551-21.481h12.168l2.752-12.91h-12.063v.105zm43.492 10.9c-8.89 0-13.228 16.614-13.228 23.704 0 4.339 1.27 7.937 6.243 7.937 8.89 0 13.122-16.613 13.122-23.704.106-4.34-1.164-7.937-6.137-7.937m-9.101 43.491c-12.486 0-22.539-6.031-22.539-19.895 0-20.105 13.332-35.449 33.756-35.449 12.486 0 22.539 6.032 22.539 19.895.106 20.106-13.227 35.449-33.756 35.449m-93.439-43.491c-8.889 0-13.227 16.614-13.227 23.704 0 4.339 1.27 7.937 6.243 7.937 8.889 0 13.122-16.613 13.122-23.704-.001-4.34-1.27-7.937-6.138-7.937m-9.206 43.491c-12.487 0-22.54-6.031-22.54-19.895 0-20.105 13.333-35.449 33.756-35.449 12.487 0 22.54 6.032 22.54 19.895.106 20.106-13.228 35.449-33.756 35.449"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M64.339 140.952c-4.974 3.281-9.841 4.445-11.217 4.762a.73.73 0 0 0-.529 1.058c1.481 2.857 5.291 9.312 12.381 14.074 6.243 4.233 13.968 1.799 17.566-4.233 2.222-3.915 3.386-10.052 1.693-15.026-1.164-3.386-3.598-5.82-6.984-6.561-.529-.105-1.058-.211-1.587-.211-3.281.106-5.927 2.539-11.323 6.137"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#FFF",
    d: "m91.64 164.021-37.989 7.408-6.879-35.45 37.99-7.408z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.979 111.111c-3.598 0-6.561 1.481-8.36 4.444-2.222 3.598-.635 6.878 1.164 14.074 1.481 5.82.846 10.688.741 12.169 0 .529.423.953.847.847 3.28-.423 10.582-1.799 17.46-6.878 6.032-4.444 6.455-12.592 1.905-17.883-2.857-3.386-8.36-6.561-13.651-6.667h-.105v-.106z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "#FFF",
    d: "m80.211 141.481-33.756 6.561-6.984-35.873 33.757-6.561z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M8.889 136.825a10.47 10.47 0 0 0-.317 2.54v.105c0 6.032 4.55 12.17 11.746 12.699 8.571.635 19.048-2.329 26.772-8.466.529-.423.423-.741.212-1.27-2.963-4.974-4.021-9.207-4.656-12.699-.741-4.762-4.233-9.312-9.841-10.582a13.424 13.424 0 0 0-2.963-.317c-8.572.001-18.625 7.514-20.953 17.99"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#f)",
    fill: "#FFF",
    d: "m53.862 151.534-43.915 8.571-7.725-39.999 43.916-8.572z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M48.042 147.619c-1.481 1.058-3.386 2.857-8.36 5.291-4.656 2.223-9.207 3.28-15.026 4.762-9.736 2.539-10.582 11.535-8.36 16.932 1.375 3.386 5.502 10.793 15.026 12.592 1.164.212 2.328.318 3.492.318h.105c9.313 0 17.672-6.667 19.577-15.979 2.116-10.794-3.704-20.952-5.291-23.704-.106-.211-.423-.423-.635-.423-.21-.001-.316.105-.528.211"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#h)",
    fill: "#FFF",
    d: "m64.127 186.138-48.571 9.418-8.995-46.667 48.571-9.418z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.153 162.539c.212-.105.529-.105.847.106.847.847 7.407 7.407 9.947 18.836-1.059.529-2.117 1.058-3.386 1.271m-7.408-20.213c.212-.105.529-.105.847.106.847.847 7.407 7.407 9.947 18.836-1.059.529-2.117 1.058-3.386 1.271-.953.211-1.905.211-2.751.211-.106-11.217-4.55-18.412-4.974-19.365"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSloveniaLotoPlus);
export default __webpack_public_path__ + "static/media/slovenia_loto_plus.bc386f67f6f2b4cd07c240a1cedb4b21.svg";
export { ForwardRef as ReactComponent };